<div class="dataset-information-wrapper">

  <!-- <div class="dataset-header">
    <h3>Dataset Information</h3>
  </div> -->
  <app-dataset-information [form]="form" mode='card' [overlayDisabled]="isColumnSettingsOpen"></app-dataset-information>
  <div class="dataset-overlay-zone">
  <!-- <div class="dataset-body">

    <div class="info-row">
      <span class="label">Name</span>
      <span class="value">{{ dataSet?.name }}</span>
    </div>

    <div class="info-row">
      <span class="label">Dataset Id</span>
      <span class="value">{{ dataSet?.id }}</span>
    </div>

    <div class="info-row">
      <span class="label">Published On</span>
      <span class="value">
        {{ dataSet?.publishedOn ? (dataSet.publishedOn | date:'medium') : 'Never Published' }}
      </span>
    </div>

  </div> -->
  <app-dataset-filter-input-config [form]="filterInputForm" [allowFiltering]="allowFiltering"
    [filterFields]="ds?.filterConfig?.fields" [columnOptions]="columnOptions"
    (allowFilteringChanged)="allowFilteringChanged($event)" (saveFilterInput)="onSaveFilterInput($event)"
    (filterSaved)="saveFilter($event)" (deleteFilterInput)="deleteFilter($event)"></app-dataset-filter-input-config>
    
  <ng-template [ngTemplateOutlet]="sortingConfigurationCardTemplate"></ng-template>
  <wm-common-dynamic-table
    [rows]="rows"
    [columns]="columns"
    [availableWorkflows]="availableWorkflows"
    [entities]="cellDropdownEntities"
    [dataSetConfig]="dataSet"
    [isNoData]="isNoData"
    [hasFewData]="hasFewData"
    [workflowDisplayNameFn]="workflowDisplayNameResolver"
    (addWorkflowRequested)="addWorkflow()"
    (deleteWorkflowRequested)="deleteWorkflow($event)"
    (workflowSelected)="selectWorkflow($event.index, $event.workflow)"
    (columnSettingsRequested)="openColumnSettings()"
    (columnEditRequested)="editColumn($event)"
    (columnDeleteRequested)="deleteColumn($event)"
    (columnMoveLeftRequested)="moveColumnLeft($event)"
    (columnMoveRightRequested)="moveColumnRight($event)"
    (columnReordered)="reorderColumn($event)"
    (cellDropdownOpened)="openCellDropdown($event.row, $event.column)"
    (cellEntitySelected)="selectCellEntity($event.row, $event.column, $event.entity)"
    (cellValueDeleted)="deleteCellValue($event.row, $event.column, $event.index)"
    (rowFiltersChanged)="onRowFiltersChange2($event.event, $event.row)">
  </wm-common-dynamic-table>
<wm-column-settings
*ngIf="isColumnSettingsOpen"
[workflowId]="selectedColumnSettingsWorkflowId"
[field]="selectedColumnSettingsField"
[containedOverlay]="true"
[overlayTopOffsetPx]="columnSettingsTopOffsetPx"
(saveColumn)="handleColumnSettingsSave($event)"
(closePanel)="closeColumnSettingsModal()">
</wm-column-settings>

<div class="button-container">
    <wm-common-button [data]="{text:'Publish Data Set',            onClick: onOpenPublishData.bind(this),
    disabled: !canPublish
}" class="publish-button" ></wm-common-button>
 <wm-common-confirmation-modal
 #publishModal
 [data]="publishDataSetModalData"
 (onNoClick)="onClosePublishData()"
 (onYesClick)="publishDataSet()"
 [isApplicantMobileview]="true"
></wm-common-confirmation-modal>
    <wm-common-button [data]="{text:'Save Data Set',onClick:saveDataSet.bind(this)}" class="button"></wm-common-button>
    <wm-common-button [data]="{text:'Test Data Set',onClick:testDataSet.bind(this),disabled: !canTest()}" class="button"></wm-common-button>

  </div>
  </div>
</div>
<ng-template #sortingConfigurationCardTemplate>
  @if (showSortingConfiguration) {
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <h4>Sorting Configuration</h4>
        </div>
        <div class="row">
          <table>
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            @if (form.controls['fieldOrder'] && dataSet?.fieldOrder && dataSet?.fields) {

            <tbody dragula="sortFields" [(dragulaModel)]="dataSet.fieldOrder" (dragulaModelChange)="orderChange()">

              @for (fo of dataSet.fieldOrder; track $index; let idx = $index) {

              <tr>

                <!-- Drag Icon -->
                <td class="drag-icon">

                  @if (dataSet.fieldOrder.length > 1) {
                  <mat-icon style="cursor: grab" matTooltip="Order the sorting priority">
                    drag_indicator
                  </mat-icon>
                  }

                </td>

                <!-- Order By -->
                <td>
                  <div class="dropdown-label-text" [class.required-placeholder]="!fo.fieldName" [matMenuTriggerFor]="orderByMenu">
                    <wm-common-text [data]="{ text: getFieldLabel(fo.fieldName) || 'ORDER BY' }">>
                    </wm-common-text>
                    <wm-common-icon [data]="{iconName:keyBoardDropDownIcon}">
                    </wm-common-icon>
                  </div>
                  <mat-menu #orderByMenu="matMenu">
                    <div style="background-color: #fff;width:205px">
                      @if (dataSet.fields.length == 0) {
                      <button mat-menu-item disabled>
                        (Add Column to Data Set)
                      </button>
                      }
                      @for (f of dataSet.fields; track f.name) {
                      <button mat-menu-item (click)="selectOrderBy(f.name, idx)">
                        {{ f.name }}
                      </button>
                      }
                    </div>
                  </mat-menu>
                  <wm-control-message
                    [control]="form.controls['fieldOrder'].controls['field' + idx]"></wm-control-message>
                </td>
                <!-- Direction -->
                <td>
                  <div class="dropdown-label-text" [class.required-placeholder]="!form.controls['fieldOrder'].controls['order' + idx].value" [matMenuTriggerFor]="directionMenu">
                    <wm-common-text
                      [data]="{ text: form.controls['fieldOrder'].controls['order' + idx].value === 1 ? 'Ascending' : form.controls['fieldOrder'].controls['order' + idx].value === 2 ? 'Descending' : 'DIRECTION' }">
                    </wm-common-text>
                    <wm-common-icon [data]="{iconName:keyBoardDropDownIcon}">
                    </wm-common-icon>
                  </div>
                  <mat-menu #directionMenu="matMenu">
                    <div style="background-color: #fff;width:205px">
                      <button mat-menu-item (click)="selectDirection(1, idx)">
                        Ascending
                      </button>
                      <button mat-menu-item (click)="selectDirection(2, idx)">
                        Descending
                      </button>
                    </div>
                  </mat-menu>
                  <wm-control-message [control]="form.controls['fieldOrder'].controls['order' + idx]">
                  </wm-control-message>
                </td>
                <!-- Delete -->
                <td>
                  @if (idx != 0) {
                  <ng-template #deleteSortingConfigurationIconTemplate>
                    <div class="delete-sorting-configuration-icon">
                      <wm-common-icon [data]="{iconName:'delete'}"></wm-common-icon>
                    </div>
                  </ng-template>
                  <wm-common-button
                    [data]="onSortingConfigurationDeleteClick(deleteSortingConfigurationIconTemplate,fo)"></wm-common-button>
                  }
                </td>
              </tr>
              }
            </tbody>
            }
          </table>
        </div>
        <!-- add button -->
        <div class="add-sorting-column-container" (click)="addSortOrder()">
          <wm-common-text [data]="{text:'+ Add Sorting Column'}"></wm-common-text>
        </div>
      </div>
    </div>
  </div>
  }
  <wm-common-confirmation-modal [data]="sortingConfigurationDeleteModalData"
    (onYesClick)="handleSortingConfigurationDeleteModalAccepted(sortingConfigurationDeleteTarget!)"
    (onNoClick)="handleSortingConfigurationDeleteModalRejected()"
    [isApplicantMobileview]="true">
  </wm-common-confirmation-modal>
</ng-template>

<wm-common-confirmation-modal
  [data]="saveSuccessModalData"
  (onOkClick)="handleSaveSuccessModalOk()"
  [isApplicantMobileview]="true">
</wm-common-confirmation-modal>

<app-loader *ngIf="executingTest"></app-loader>

<div class="card" *ngIf="resultColumns && resultRows">
  <div class="test-results-header">
    <div class="test-results-title">
      <wm-common-text [data]="{ text: 'Test Data Set Results' }"></wm-common-text>
    </div>
    <button
      type="button"
      class="test-results-close-btn"
      aria-label="Close test results"
      (click)="closeTestResults()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="card-body">
    <wm-common-table
      tableType="Staff"
      [columns]="resultColumns"
      [data]="resultRows"
      [defaultPageSize]="10"
      [showRowsPerPage]="true">
    </wm-common-table>
  </div>
</div>

<div class="card" *ngFor="let aggResultKey of aggResultKeys">
  <div class="card-body" *ngIf="aggregatedResultColumns?.[aggResultKey] && aggregatedResultRows?.[aggResultKey]">
    <div class="card-title">
      <h4>{{ aggResultKey }}</h4>
    </div>
    <wm-common-table
      tableType="Staff"
      [columns]="aggregatedResultColumns[aggResultKey]"
      [data]="aggregatedResultRows[aggResultKey]"
      [defaultPageSize]="10"
      [showRowsPerPage]="true">
    </wm-common-table>
  </div>
</div>
